// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import { InjectedFormProps } from 'redux-form'; // eslint-disable-line no-unused-vars
import classes from './PatientChooseModal.module.scss';
import HForm, { TextField } from 'shared/containers/portal_layout/HForm';
import { reduxForm } from 'utils/reduxFormWrapper';
import Errors from 'shared/components/Errors';
import SpinnerButton from 'shared/components/SpinnerButton';
import { Referral } from '../types'; // eslint-disable-line no-unused-vars

/** @typedef {{
  patientEmail: string,
  formattedPrimaryPhone: string
}} PatientChooseFormType */

/** @typedef {{
  referral: Referral,
  onPatientChooseSubmit: (formValues: PatientChooseFormType) => Promise
}} PatientChooseModalPropsType */

/**
 * @todo these ought to be required, but don't exist when modal is not open
 * @type { React.ValidationMap<PatientChooseModalPropsType> } */
const propTypes = {
  referral: PropTypes.object,
  onPatientChooseSubmit: PropTypes.func,
};

/** @type { StatelessComponent<PatientChooseModalPropsType> } */
const PatientChooseModal = ({ referral, onPatientChooseSubmit }) => (
  <FormifiedPresentationComponent
    form="patientChoose"
    hasExistingReferral={!!referral}
    initialValues={referral}
    onSubmit={onPatientChooseSubmit}
  />
);

PatientChooseModal.displayName = 'PatientChooseModal';
PatientChooseModal.propTypes = propTypes;

/** @typedef {{
  hasExistingReferral: boolean
} & InjectedFormProps<PatientChooseFormType>} PresentationComponentPropsType */

/** @type { React.ValidationMap<PresentationComponentPropsType> } */
const presentationComponentPropTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  error: PropTypes.object,
  hasExistingReferral: PropTypes.bool.isRequired,
};

/** @type { StatelessComponent<PresentationComponentPropsType> }  */
const PresentationComponent = ({
  handleSubmit,
  submitting,
  error,
  hasExistingReferral,
}) => (
  <div className={classes.modal}>
    <div className={classes.header}>
      <p className={classes.headerText}>
        Instead of choosing for the patient, you can enter the patient's phone
        and email, and AristaMD will still track and help fulfill the referral.
        The list will also be emailed to the patient, with a link to book.
      </p>
    </div>
    <HForm onSubmit={handleSubmit}>
      <Errors errors={error || []} />
      <div className={classes.midsection}>
        {hasExistingReferral || (
          <TextField name="patientEmail" label="Patient Email" />
        )}
        <TextField name="formattedPrimaryPhone" label="Patient Phone" />
      </div>
      <div className={classes.footer}>
        <SpinnerButton
          type="submit"
          className="btn btn-primary"
          loading={submitting}
        >
          Save
        </SpinnerButton>
      </div>
    </HForm>
  </div>
);

PresentationComponent.displayName = 'PresentationComponent';
PresentationComponent.propTypes = presentationComponentPropTypes;

const FormifiedPresentationComponent = reduxForm({})(PresentationComponent);

export default PatientChooseModal;
